"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RejectError_1 = require("../DOM/Error/RejectError");
const UnhandledRejectionHandler_1 = require("../DOM/UnhandledRejectionHandler");
class Promise extends window.Promise {
    constructor(executor) {
        super((resolve, reject) => executor(resolve, reason => reject(Promise.normalizeReason(reason))));
    }
    /**
     * By default when an Error is thrown inside a promise call, the promise will handle the error and will forward it to the
     * `catch` method. In turn the catch method will just be invoked without notifying about the specifics of the error, making debugging extremely
     * difficult. Solution: wrap the catch method in a custom handler, and when we get specific Error or Exception, send to the console.
     */
    catch(onRejected) {
        return super.catch((reason) => {
            const abortError = reason instanceof DOMException && (reason.code === DOMException.ABORT_ERR || reason.name === 'AbortError');
            const rejectError = reason instanceof RejectError_1.default;
            // send all error messages to the console except aborted request errors
            if (reason instanceof Error && abortError === false && rejectError === false) {
                if (reason.message === 'Failed to fetch') {
                    console.info(reason);
                }
                else {
                    console.error(reason);
                }
            }
            return onRejected === undefined || onRejected === null ? Promise.reject() : onRejected(reason);
        });
    }
    static reject(reason) {
        return super.reject(Promise.normalizeReason(reason));
    }
    static normalizeReason(reason) {
        if (typeof reason === 'string') {
            reason = new RejectError_1.default(reason);
        }
        else if (reason instanceof Error === false) {
            reason = new RejectError_1.default(undefined, reason);
        }
        return reason;
    }
}
exports.default = Promise;
(() => {
    /**
     * When a promise is rejected but has no .catch() method, the browser will throw an unhandled rejection exception.
     * Allow promises to be rejected without catch by suppressing the error handler, only when a Promise is rejected without an error
     */
    // istanbul ignore next
    window.addEventListener('unhandledrejection', UnhandledRejectionHandler_1.default);
})();
//# sourceMappingURL=Promise.js.map